export default __webpack_public_path__ + "static/media/lions.1e5dbac7.gif";